import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useRouter, RouterProps } from './useRouter'
import Layout from 'components/Layout/Layout'
import Home from 'screens/Home/Home'
import About from 'screens/About/About'
import Departments from 'screens/Departments/Departments'
import DepartmentDetails from 'screens/DepartmentDetails/DepartmentDetails'
import NewsListing from 'screens/NewsListing/NewsListing'
import NewsDetails from 'screens/NewsDetails/NewsDetails'
import OurTeam from 'screens/OurTeam/OurTeam'
import Contact from 'screens/Contact/Contact'
import Support from 'screens/Support/Support'

const Router: React.FC<RouterProps> = (props: RouterProps) => {
  const {} = useRouter(props)

  return (
    <BrowserRouter>
      <Layout isLoading={false}>
        <Routes>
          <Route path='/' element={<Navigate to='/ar' replace />} />
          <Route path='/:lang' element={<Home />} />
          <Route path='/:lang/About' element={<About />} />
          <Route path='/:lang/Departments' element={<Departments />} />
          <Route
            path='/:lang/Departments/:slug'
            element={<DepartmentDetails />}
          />
          <Route path='/:lang/News' element={<NewsListing />} />
          <Route path='/:lang/NewsDetails/:slug' element={<NewsDetails />} />
          <Route path='/:lang/OurTeam' element={<OurTeam />} />
          <Route path='/:lang/Contact' element={<Contact />} />
          <Route path='/:lang/Support' element={<Support />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  )
}

export default Router
